// @flow
import * as React from 'react';

import { useDispatch } from 'react-redux';

import {
  selectCartOwnerIsReseller,
  selectCartProductOwner,
  selectCartOwner,
  selectCartReselleeID,
  setCartOwnerIsReseller,
} from '@gandi/cart';

import { useQuery } from 'src/helpers/withRouter';
import type { Query } from 'src/helpers/withRouter';
import { useAppSelector } from 'src/hooks/useAppSelector';

type Props = {
  isReseller: boolean,
};

type ProductOwnerChoice = {
  checked: boolean,
  setChecked: React.ReactSetStateFunction<boolean>,
};

export function useProductOwnerChoice({
  isReseller,
}: Props): ProductOwnerChoice {
  const dispatch = useDispatch();
  const { firstBuy } = useQuery<Query>();

  const cartOwnerId = useAppSelector(selectCartOwner);
  const productOwnerId = useAppSelector(selectCartProductOwner);
  const reselleeId = useAppSelector(selectCartReselleeID);

  // WARN: selectCartOwnerIsReseller is used to tell
  // if user just selected a reseller as cart owner
  // it will be unset when user ticks this checkbox
  const cartOwnerIsReseller = useAppSelector(selectCartOwnerIsReseller);

  const [checked, setChecked] = React.useState(
    cartOwnerId === productOwnerId ||
      (!isReseller && !firstBuy && !productOwnerId && !reselleeId),
  );

  React.useEffect(() => {
    if (cartOwnerIsReseller) {
      setChecked(false);
    }
  }, [cartOwnerIsReseller]);

  React.useEffect(() => {
    dispatch(setCartOwnerIsReseller(isReseller));
  }, [dispatch, isReseller]);

  React.useEffect(() => {
    if (cartOwnerId === productOwnerId) {
      setChecked(true);
    }
  }, [cartOwnerId, productOwnerId]);

  return {
    checked,
    setChecked,
  };
}
